import skuDao from '../../../dao/skuDao';
import {push} from 'react-router-redux';
import skutypes from '../../../utils/config/skutypes';

const RESET = 'pages/products/addoreditsku/RESET';
const ADD_SKU = 'pages/products/addoreditsku/ADD_SKU';
const QUERY_SKU = 'pages/products/addoreditsku/QUERY_SKU';
const QUERY_SKU_SUCCESS = 'pages/products/addoreditsku/QUERY_SKU_SUCCESS';
const EDIT_SKU = 'pages/products/addoreditsku/EDIT_SKU';
const CREATE_SKU = 'pages/products/addoreditsku/CREATE_SKU';
const CREATE_SKU_SUCCESS = 'pages/products/addoreditsku/CREATE_SKU_SUCCESS';
const UPDATE_SKU = 'pages/products/addoreditsku/UPDATE_SKU';
const UPDATE_SKU_SUCCESS = 'pages/products/addoreditsku/UPDATE_SKU_SUCCESS';
const QUERY_DATA_URL_SUCCESS = 'pages/products/addoreditsku/QUERY_DATA_URL_SUCCESS';

const initialState = {
  isLoaded: false,
  sku: {
    colors: [],
    createdTime: 0,
    enabled: false,
    gtin: '',
    id: -1,
    imageUrl: '',
    lastModified: 0,
    patternGuid: '',
    skuName: '',
    skuNo: '',
    skuStatus: false,
    skuType: 'BLUSH',
    shopUrl: '',
  },
};
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case RESET:
      return {...initialState};
    case ADD_SKU:
      return {
        ...state,
        isLoaded: true,
        skuType: action.skuType,
        sku: action.sku,
      };
    case EDIT_SKU:
      return {
        ...state,
        isLoaded: true,
        skuType: action.skuType,
        sku: action.sku,
      };
    case CREATE_SKU:
      return {
        ...state,
      };
    case CREATE_SKU_SUCCESS:
      return {
        ...state,
      };
    case UPDATE_SKU:
      return {
        ...state,
      };
    case UPDATE_SKU_SUCCESS:
      return {
        ...state,
      };
    case QUERY_DATA_URL_SUCCESS:
      return {
        ...state,
        imageDataUrl: action.dataUrl
      };
    default:
      return state;
  }
};

export function reset() {
  return {
    type: RESET,
  };
}

export function addSku(skuType = skutypes.getSkuTypes().blush.type, platformData) {
  if (skuType === 'tutorial') {
    return {
      type: ADD_SKU,
      skuType: 'LIPCOLOR',
      sku: {
        skuType: 'LIPCOLOR',
        skuNo: '',
        gtin: '',
        skuName: 'Lipstick Demo',
        color: '#e0467c',
        patternGuid: 'patten_lipstick_01',
        colorIntensity: 38,
        glossIntensity: 50,
        shimmerIntensity: 50,
        shimmerDensity: 50,
        shimmerColor: '#eeeeee',
        shimmerGranularity: 50,
        imageUrl:
          'https://plugins-media.makeupar.com/smb/story/2022-10-03/6f43761a-5700-461d-b0ce-0bdc37172b7c.jpg',
        shopUrl: '',
      },
    };
  }
  return {
    type: ADD_SKU,
    skuType,
    sku: skuDao.initSku(skuType, platformData),
  };
}

export function querySku(skuId) {
  return dispatch => {
    dispatch({
      type: QUERY_SKU,
    });
    return skuDao.querySku(skuId).then(json => {
      dispatch({
        type: QUERY_SKU_SUCCESS,
      });
      return json;
    });
  };
}

export function editSku(sku) {
  return {
    type: EDIT_SKU,
    sku,
    skuType: sku.skuType,
  };
}

export function createSku(sku) {
  return dispatch => {
    dispatch({
      type: CREATE_SKU,
    });
    return skuDao.createSku(sku).then(r => {
      dispatch({
        type: CREATE_SKU_SUCCESS,
      });
      dispatch(push({pathname: '/products/list-skus'}));
      return r;
    });
  };
}

export function updateSku(sku) {
  return dispatch => {
    dispatch({
      type: UPDATE_SKU,
    });
    return skuDao.updateSku(sku).then(r => {
      dispatch({
        type: UPDATE_SKU_SUCCESS,
      });
      dispatch(push({pathname: '/products/list-skus'}));
      return r;
    });
  };
}

export function queryDataUrl(url) {
  return dispatch => {
    return skuDao.queryDataUrl(url).then(r => {
      dispatch({
        type: QUERY_DATA_URL_SUCCESS,
        dataUrl: r.dataUrl
      });
      return r;
    });
  };
}
